import { Button, Text } from '@mantine/core';
import React from 'react';
import { defaultTheme } from '@dealstack/frontend/shared/mechanism/styleguide/defaultTheme';

export const DefaultBorderColor = '#E6E9EB';
export const ActiveBorderColor = defaultTheme.v3.colors.blue[4];

interface Props extends React.HTMLProps<HTMLDivElement> {
	mainTitle: React.ReactNode;
	action: string;
	onClick: () => void;
	canPerformAction: boolean;
	isEditModeEnabled: boolean;
	borderColor?: string;
}

export const Header = ({
	mainTitle,
	action,
	onClick,
	canPerformAction,
	isEditModeEnabled,
	borderColor,
	...props
}: Props) => {
	const renderTitle = () => {
		if (typeof mainTitle === 'string') {
			return (
				<Text size="B6Bold" c="dark.8">
					{mainTitle}
				</Text>
			);
		} else {
			return mainTitle;
		}
	};
	return (
		<div
			className="flex p-4 items-center justify-between border border-solid rounded-t-lg bg-[#F4F5F6]"
			style={{
				borderColor: isEditModeEnabled
					? ActiveBorderColor
					: borderColor ?? DefaultBorderColor,
			}}
		>
			{renderTitle()}
			{canPerformAction && (
				<Button
					className="p-0"
					variant="link-color"
					onClick={onClick}
					data-testid={props['data-testid']}
				>
					{action}
				</Button>
			)}
		</div>
	);
};
